module.exports = __webpack_public_path__ + "img/Prepnextyear.05f430cc.jpg";